import { KeyboardEvent, MouseEvent, useEffect, useRef } from 'react';
import { SelectOption } from './SelectProps.ts';
import { getKeys } from '../../../../_helpers/keyboard.ts';

export const Option: React.FC<{
	opened: boolean;
	option: SelectOption;
	isSelected: boolean;
	autofocus?: boolean;
	onSelect: (
		event: MouseEvent<HTMLLIElement> | KeyboardEvent<HTMLLIElement>
	) => void;
}> = ({ opened, option, onSelect, isSelected, autofocus = false }) => {
	const listItem = useRef<HTMLLIElement>();
	function onClickItem(event: MouseEvent<HTMLLIElement>): void {
		event.stopPropagation();
		onSelect(event);
	}

	function onItemKeyDown(event: KeyboardEvent<HTMLLIElement>): void {
		const keys = getKeys(event);
		if (keys.isEnter || keys.isSpace) {
			onSelect(event);
		}
	}
	const { isDisabled, label } = option;

	useEffect(() => {
		if (autofocus && listItem.current) {
			listItem.current?.focus();
		}
	}, [listItem, opened, autofocus]);
	return (
		<>
			<li
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore
				ref={listItem}
				onClick={(ev) => onClickItem(ev)}
				onMouseDown={(e) => e.preventDefault()}
				className={
					'select-option' +
					(isDisabled ? ' disabled' : '') +
					(isSelected ? ' selected blk-ac-body-m-bold' : ' blk-ac-body-m')
				}
				role="option"
				aria-selected={isSelected}
				tabIndex={opened ? 0 : -1}
				onKeyDown={(ev) => onItemKeyDown(ev)}
			>
				<span className="select-option-label">{label}</span>
				{isSelected && <i className="icon fas fa-check"></i>}
			</li>
		</>
	);
};
